/* eslint-disable max-len */
import React, { useState } from 'react';
import {
  Card,
  Modal,
  Typography,
  List,
  Checkbox,
  Tag,
  Button,
  Space,
  Tooltip,
  Tabs,
  notification,
} from 'antd';
import { UserOutlined, CheckCircleOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const { TabPane } = Tabs;

export default function Contratacion() {
  const vacantes = [
    {
      id: 1,
      solicitudFecha: '15/03/2023',
      solicitudFolio: 'SOL-2023-001',
      solicitanteNombre: 'Juan Pérez Rodríguez',
      solicitanteAreaCodigo: 'A001',
      solicitanteAreaNombre: 'Tecnología',
      solicitantePuesto: 'Gerente de Desarrollo',
      vacanteCodigo: 'PL001',
      vacantePlaza: 'Desarrollador Frontend',
      vacanteAreaCodigo: 'A001',
      vacanteAreaNombre: 'Tecnología',
      vacantePuesto: 'Desarrollador Senior',
      empleadoTipo: 'Tiempo Completo',
      oficioNumero: 'TEC-2023-045',
      vacanteMotivo: 'Crecimiento del equipo',
      vacanteEstatus: 'En Reclutamiento',
      pruebasAsignadas: ['Técnica Frontend', 'Psicométrica General'],
      candidatosTotal: 8,
    },
    {
      id: 2,
      solicitudFecha: '20/03/2023',
      solicitudFolio: 'SOL-2023-002',
      solicitanteNombre: 'María López García',
      solicitanteAreaCodigo: 'A002',
      solicitanteAreaNombre: 'Recursos Humanos',
      solicitantePuesto: 'Jefe de Selección',
      vacanteCodigo: 'PL002',
      vacantePlaza: 'Analista de Recursos Humanos',
      vacanteAreaCodigo: 'A002',
      vacanteAreaNombre: 'Recursos Humanos',
      vacantePuesto: 'Analista Senior',
      empleadoTipo: 'Medio Tiempo',
      oficioNumero: 'RH-2023-012',
      vacanteMotivo: 'Reemplazo por vacaciones',
      vacanteEstatus: 'Cita para Entrevista',
      pruebasAsignadas: ['Psicométrica General'],
      candidatosTotal: 5,
    },
    {
      id: 3,
      solicitudFecha: '25/03/2023',
      solicitudFolio: 'SOL-2023-003',
      solicitanteNombre: 'Pedro Martínez Sánchez',
      solicitanteAreaCodigo: 'A003',
      solicitanteAreaNombre: 'Ventas',
      solicitantePuesto: 'Gerente de Ventas',
      vacanteCodigo: 'PL003',
      vacantePlaza: 'Ejecutivo de Ventas',
      vacanteAreaCodigo: 'A003',
      vacanteAreaNombre: 'Ventas',
      vacantePuesto: 'Ejecutivo Junior',
      empleadoTipo: 'Tiempo Completo',
      oficioNumero: 'VEN-2023-078',
      vacanteMotivo: 'Expansión de mercado',
      vacanteEstatus: 'Activa',
      pruebasAsignadas: [],
      candidatosTotal: 12,
    },
    {
      id: 4,
      solicitudFecha: '30/03/2023',
      solicitudFolio: 'SOL-2023-004',
      solicitanteNombre: 'Laura Fernández Torres',
      solicitanteAreaCodigo: 'A004',
      solicitanteAreaNombre: 'Marketing',
      solicitantePuesto: 'Directora de Marketing',
      vacanteCodigo: 'PL004',
      vacantePlaza: 'Diseñador Gráfico',
      vacanteAreaCodigo: 'A004',
      vacanteAreaNombre: 'Marketing',
      vacantePuesto: 'Diseñador Junior',
      empleadoTipo: 'Freelance',
      oficioNumero: 'MAR-2023-034',
      vacanteMotivo: 'Proyecto temporal',
      vacanteEstatus: 'Cancelada',
      pruebasAsignadas: ['Creatividad'],
      candidatosTotal: 0,
    },
    {
      id: 5,
      solicitudFecha: '05/04/2023',
      solicitudFolio: 'SOL-2023-005',
      solicitanteNombre: 'Sofía Ramírez Pérez',
      solicitanteAreaCodigo: 'A005',
      solicitanteAreaNombre: 'Finanzas',
      solicitantePuesto: 'CFO',
      vacanteCodigo: 'PL005',
      vacantePlaza: 'Contador Público',
      vacanteAreaCodigo: 'A005',
      vacanteAreaNombre: 'Finanzas',
      vacantePuesto: 'Contador Senior',
      empleadoTipo: 'Tiempo Completo',
      oficioNumero: 'FIN-2023-056',
      vacanteMotivo: 'Reemplazo por jubilación',
      vacanteEstatus: 'Seleccionado(a)',
      pruebasAsignadas: ['Contabilidad Avanzada'],
      candidatosTotal: 3,
    },
  ];
  const candidatos = [
    // PL001 - Desarrollador Frontend
    {
      id: 1,
      nombre: 'Carlos Méndez',
      email: 'carlos.mendez@ejemplo.com',
      telefono: '555-000-1001',
      estatus: 'Entrevistado',
      experiencia: '5 años',
      fechaAplicacion: '18/04/2023',
      escolaridad: 'Lic. en Sistemas Computacionales',
      institucion: 'UNAM',
      anioGraduacion: '2018',
      cvURL: 'https://example.com/cv/carlos-mendez.pdf',
      vacanteCodigo: 'PL001',
      vacantePlaza: 'Desarrollador Frontend',
      vacantePuesto: 'Desarrollador Senior',
      vacanteTipoEmpleado: 'Tiempo Completo',
      vacanteOficio: 'TEC-2023-045',
      vacanteMotivo: 'Crecimiento del equipo',
      vacanteEstatus: 'En Reclutamiento',
      vacantePruebas: ['Técnica Frontend', 'Psicométrica General'],
      solicitanteFolio: 'SOL-2023-001',
      solicitanteNombre: 'Juan Pérez Rodríguez',
      solicitantePuesto: 'Gerente de Desarrollo',
      solicitanteAreaCodigo: 'A001',
      solicitanteAreaNombre: 'Tecnología',
      resumenEntrevista: 'Perfil técnico sólido, destaca en React y buenas prácticas.',
      archivoEntrevista: 'https://example.com/entrevistas/carlos-mendez.pdf',
    },
    {
      id: 2,
      nombre: 'Erika González',
      email: 'erika.gonzalez@ejemplo.com',
      telefono: '555-000-1012',
      estatus: 'Entrevistado',
      experiencia: '3 años',
      fechaAplicacion: '19/04/2023',
      escolaridad: 'Ing. en Software',
      institucion: 'IPN',
      anioGraduacion: '2020',
      cvURL: 'https://example.com/cv/erika-gonzalez.pdf',
      vacanteCodigo: 'PL001',
      vacantePlaza: 'Desarrollador Frontend',
      vacantePuesto: 'Desarrollador Senior',
      vacanteTipoEmpleado: 'Tiempo Completo',
      vacanteOficio: 'TEC-2023-045',
      vacanteMotivo: 'Crecimiento del equipo',
      vacanteEstatus: 'En Reclutamiento',
      vacantePruebas: ['Técnica Frontend'],
      solicitanteFolio: 'SOL-2023-001',
      solicitanteNombre: 'Juan Pérez Rodríguez',
      solicitantePuesto: 'Gerente de Desarrollo',
      solicitanteAreaCodigo: 'A001',
      solicitanteAreaNombre: 'Tecnología',
      resumenEntrevista: 'Manejo sólido de Vue y experiencia en diseño de componentes.',
      archivoEntrevista: 'https://example.com/entrevistas/erika-gonzalez.pdf',
    },
    {
      id: 3,
      nombre: 'David Romero',
      email: 'david.romero@ejemplo.com',
      telefono: '555-000-1013',
      estatus: 'Entrevistado',
      experiencia: '4 años',
      fechaAplicacion: '20/04/2023',
      escolaridad: 'Lic. en Tecnologías de la Información',
      institucion: 'UAM',
      anioGraduacion: '2019',
      cvURL: 'https://example.com/cv/david-romero.pdf',
      vacanteCodigo: 'PL001',
      vacantePlaza: 'Desarrollador Frontend',
      vacantePuesto: 'Desarrollador Senior',
      vacanteTipoEmpleado: 'Tiempo Completo',
      vacanteOficio: 'TEC-2023-045',
      vacanteMotivo: 'Crecimiento del equipo',
      vacanteEstatus: 'En Reclutamiento',
      vacantePruebas: ['Psicométrica General'],
      solicitanteFolio: 'SOL-2023-001',
      solicitanteNombre: 'Juan Pérez Rodríguez',
      solicitantePuesto: 'Gerente de Desarrollo',
      solicitanteAreaCodigo: 'A001',
      solicitanteAreaNombre: 'Tecnología',
      resumenEntrevista: 'Buen dominio de Git, proactivo, con atención al detalle.',
      archivoEntrevista: 'https://example.com/entrevistas/david-romero.pdf',
    },

    // PL002 - Analista de Recursos Humanos
    {
      id: 4,
      nombre: 'Ana Torres',
      email: 'ana.torres@ejemplo.com',
      telefono: '555-000-2002',
      estatus: 'Entrevistado',
      experiencia: '4 años',
      fechaAplicacion: '19/04/2023',
      escolaridad: 'Lic. en Psicología',
      institucion: 'IPN',
      anioGraduacion: '2019',
      cvURL: 'https://example.com/cv/ana-torres.pdf',
      vacanteCodigo: 'PL002',
      vacantePlaza: 'Analista de Recursos Humanos',
      vacantePuesto: 'Analista Senior',
      vacanteTipoEmpleado: 'Medio Tiempo',
      vacanteOficio: 'RH-2023-012',
      vacanteMotivo: 'Reemplazo por vacaciones',
      vacanteEstatus: 'Cita para Entrevista',
      vacantePruebas: ['Psicométrica General'],
      solicitanteFolio: 'SOL-2023-002',
      solicitanteNombre: 'María López García',
      solicitantePuesto: 'Jefe de Selección',
      solicitanteAreaCodigo: 'A002',
      solicitanteAreaNombre: 'Recursos Humanos',
      resumenEntrevista: 'Buen juicio organizacional y empatía en entrevistas.',
      archivoEntrevista: 'https://example.com/entrevistas/ana-torres.pdf',
    },
    {
      id: 5,
      nombre: 'Iván Carrillo',
      email: 'ivan.carrillo@ejemplo.com',
      telefono: '555-000-2010',
      estatus: 'Entrevistado',
      experiencia: '6 años',
      fechaAplicacion: '20/04/2023',
      escolaridad: 'Lic. en Administración',
      institucion: 'UVM',
      anioGraduacion: '2016',
      cvURL: 'https://example.com/cv/ivan-carrillo.pdf',
      vacanteCodigo: 'PL002',
      vacantePlaza: 'Analista de Recursos Humanos',
      vacantePuesto: 'Analista Senior',
      vacanteTipoEmpleado: 'Medio Tiempo',
      vacanteOficio: 'RH-2023-012',
      vacanteMotivo: 'Reemplazo por vacaciones',
      vacanteEstatus: 'Cita para Entrevista',
      vacantePruebas: ['Psicométrica General'],
      solicitanteFolio: 'SOL-2023-002',
      solicitanteNombre: 'María López García',
      solicitantePuesto: 'Jefe de Selección',
      solicitanteAreaCodigo: 'A002',
      solicitanteAreaNombre: 'Recursos Humanos',
      resumenEntrevista: 'Amplia experiencia en nóminas y selección. Responsable y adaptable.',
      archivoEntrevista: 'https://example.com/entrevistas/ivan-carrillo.pdf',
    },
    {
      id: 6,
      nombre: 'Leticia Ramos',
      email: 'leticia.ramos@ejemplo.com',
      telefono: '555-000-2011',
      estatus: 'Entrevistado',
      experiencia: '2 años',
      fechaAplicacion: '21/04/2023',
      escolaridad: 'Lic. en Recursos Humanos',
      institucion: 'UANL',
      anioGraduacion: '2021',
      cvURL: 'https://example.com/cv/leticia-ramos.pdf',
      vacanteCodigo: 'PL002',
      vacantePlaza: 'Analista de Recursos Humanos',
      vacantePuesto: 'Analista Senior',
      vacanteTipoEmpleado: 'Medio Tiempo',
      vacanteOficio: 'RH-2023-012',
      vacanteMotivo: 'Reemplazo por vacaciones',
      vacanteEstatus: 'Cita para Entrevista',
      vacantePruebas: ['Psicométrica General'],
      solicitanteFolio: 'SOL-2023-002',
      solicitanteNombre: 'María López García',
      solicitantePuesto: 'Jefe de Selección',
      solicitanteAreaCodigo: 'A002',
      solicitanteAreaNombre: 'Recursos Humanos',
      resumenEntrevista: 'Alta disposición de aprendizaje, enfocada en clima laboral y entrevistas.',
      archivoEntrevista: 'https://example.com/entrevistas/leticia-ramos.pdf',
    },
    // PL003 - Ejecutivo de Ventas
    {
      id: 7,
      nombre: 'Luis Navarro',
      email: 'luis.navarro@ejemplo.com',
      telefono: '555-000-3003',
      estatus: 'Entrevistado',
      experiencia: '3 años',
      fechaAplicacion: '21/04/2023',
      escolaridad: 'Lic. en Mercadotecnia',
      institucion: 'UVM',
      anioGraduacion: '2020',
      cvURL: 'https://example.com/cv/luis-navarro.pdf',
      vacanteCodigo: 'PL003',
      vacantePlaza: 'Ejecutivo de Ventas',
      vacantePuesto: 'Ejecutivo Junior',
      vacanteTipoEmpleado: 'Tiempo Completo',
      vacanteOficio: 'VEN-2023-078',
      vacanteMotivo: 'Expansión de mercado',
      vacanteEstatus: 'Activa',
      vacantePruebas: [],
      solicitanteFolio: 'SOL-2023-003',
      solicitanteNombre: 'Pedro Martínez Sánchez',
      solicitantePuesto: 'Gerente de Ventas',
      solicitanteAreaCodigo: 'A003',
      solicitanteAreaNombre: 'Ventas',
      resumenEntrevista: 'Enfocado en resultados, buena actitud y habilidades comerciales.',
      archivoEntrevista: 'https://example.com/entrevistas/luis-navarro.pdf',
    },
    {
      id: 8,
      nombre: 'Norma Varela',
      email: 'norma.varela@ejemplo.com',
      telefono: '555-000-3004',
      estatus: 'Entrevistado',
      experiencia: '5 años',
      fechaAplicacion: '22/04/2023',
      escolaridad: 'Lic. en Administración',
      institucion: 'UNAM',
      anioGraduacion: '2017',
      cvURL: 'https://example.com/cv/norma-varela.pdf',
      vacanteCodigo: 'PL003',
      vacantePlaza: 'Ejecutivo de Ventas',
      vacantePuesto: 'Ejecutivo Junior',
      vacanteTipoEmpleado: 'Tiempo Completo',
      vacanteOficio: 'VEN-2023-078',
      vacanteMotivo: 'Expansión de mercado',
      vacanteEstatus: 'Activa',
      vacantePruebas: [],
      solicitanteFolio: 'SOL-2023-003',
      solicitanteNombre: 'Pedro Martínez Sánchez',
      solicitantePuesto: 'Gerente de Ventas',
      solicitanteAreaCodigo: 'A003',
      solicitanteAreaNombre: 'Ventas',
      resumenEntrevista: 'Excelente capacidad de persuasión. Orientada a metas.',
      archivoEntrevista: 'https://example.com/entrevistas/norma-varela.pdf',
    },
    {
      id: 9,
      nombre: 'Eduardo Salgado',
      email: 'eduardo.salgado@ejemplo.com',
      telefono: '555-000-3005',
      estatus: 'Entrevistado',
      experiencia: '2 años',
      fechaAplicacion: '23/04/2023',
      escolaridad: 'Lic. en Negocios Internacionales',
      institucion: 'ITESM',
      anioGraduacion: '2021',
      cvURL: 'https://example.com/cv/eduardo-salgado.pdf',
      vacanteCodigo: 'PL003',
      vacantePlaza: 'Ejecutivo de Ventas',
      vacantePuesto: 'Ejecutivo Junior',
      vacanteTipoEmpleado: 'Tiempo Completo',
      vacanteOficio: 'VEN-2023-078',
      vacanteMotivo: 'Expansión de mercado',
      vacanteEstatus: 'Activa',
      vacantePruebas: [],
      solicitanteFolio: 'SOL-2023-003',
      solicitanteNombre: 'Pedro Martínez Sánchez',
      solicitantePuesto: 'Gerente de Ventas',
      solicitanteAreaCodigo: 'A003',
      solicitanteAreaNombre: 'Ventas',
      resumenEntrevista: 'Perfil joven pero con alto potencial comercial y ambición.',
      archivoEntrevista: 'https://example.com/entrevistas/eduardo-salgado.pdf',
    },

    // PL004 - Diseñador Gráfico
    {
      id: 10,
      nombre: 'Mariana Ruiz',
      email: 'mariana.ruiz@ejemplo.com',
      telefono: '555-000-4004',
      estatus: 'Entrevistado',
      experiencia: '2 años',
      fechaAplicacion: '22/04/2023',
      escolaridad: 'Lic. en Diseño Gráfico',
      institucion: 'UAM',
      anioGraduacion: '2021',
      cvURL: 'https://example.com/cv/mariana-ruiz.pdf',
      vacanteCodigo: 'PL004',
      vacantePlaza: 'Diseñador Gráfico',
      vacantePuesto: 'Diseñador Junior',
      vacanteTipoEmpleado: 'Freelance',
      vacanteOficio: 'MAR-2023-034',
      vacanteMotivo: 'Proyecto temporal',
      vacanteEstatus: 'Cancelada',
      vacantePruebas: ['Creatividad'],
      solicitanteFolio: 'SOL-2023-004',
      solicitanteNombre: 'Laura Fernández Torres',
      solicitantePuesto: 'Directora de Marketing',
      solicitanteAreaCodigo: 'A004',
      solicitanteAreaNombre: 'Marketing',
      resumenEntrevista: 'Creativa, buen ojo visual. Lista para trabajar por entregables.',
      archivoEntrevista: 'https://example.com/entrevistas/mariana-ruiz.pdf',
    },
    {
      id: 11,
      nombre: 'Diego León',
      email: 'diego.leon@ejemplo.com',
      telefono: '555-000-4005',
      estatus: 'Entrevistado',
      experiencia: '4 años',
      fechaAplicacion: '23/04/2023',
      escolaridad: 'Lic. en Artes Visuales',
      institucion: 'ENAP',
      anioGraduacion: '2019',
      cvURL: 'https://example.com/cv/diego-leon.pdf',
      vacanteCodigo: 'PL004',
      vacantePlaza: 'Diseñador Gráfico',
      vacantePuesto: 'Diseñador Junior',
      vacanteTipoEmpleado: 'Freelance',
      vacanteOficio: 'MAR-2023-034',
      vacanteMotivo: 'Proyecto temporal',
      vacanteEstatus: 'Cancelada',
      vacantePruebas: ['Creatividad'],
      solicitanteFolio: 'SOL-2023-004',
      solicitanteNombre: 'Laura Fernández Torres',
      solicitantePuesto: 'Directora de Marketing',
      solicitanteAreaCodigo: 'A004',
      solicitanteAreaNombre: 'Marketing',
      resumenEntrevista: 'Experto en diseño editorial y branding. Proyectos freelance previos exitosos.',
      archivoEntrevista: 'https://example.com/entrevistas/diego-leon.pdf',
    },

    // PL005 - Contador Público
    {
      id: 12,
      nombre: 'Fernando Salas',
      email: 'fernando.salas@ejemplo.com',
      telefono: '555-000-5005',
      estatus: 'Entrevistado',
      experiencia: '8 años',
      fechaAplicacion: '23/04/2023',
      escolaridad: 'Lic. en Contaduría Pública',
      institucion: 'ITESM',
      anioGraduacion: '2015',
      cvURL: 'https://example.com/cv/fernando-salas.pdf',
      vacanteCodigo: 'PL005',
      vacantePlaza: 'Contador Público',
      vacantePuesto: 'Contador Senior',
      vacanteTipoEmpleado: 'Tiempo Completo',
      vacanteOficio: 'FIN-2023-056',
      vacanteMotivo: 'Reemplazo por jubilación',
      vacanteEstatus: 'Seleccionado(a)',
      vacantePruebas: ['Contabilidad Avanzada'],
      solicitanteFolio: 'SOL-2023-005',
      solicitanteNombre: 'Sofía Ramírez Pérez',
      solicitantePuesto: 'CFO',
      solicitanteAreaCodigo: 'A005',
      solicitanteAreaNombre: 'Finanzas',
      resumenEntrevista: 'Altamente calificado. Dominio técnico contable, responsable y confiable.',
      archivoEntrevista: 'https://example.com/entrevistas/fernando-salas.pdf',
    },
    {
      id: 13,
      nombre: 'Daniela Vélez',
      email: 'daniela.velez@ejemplo.com',
      telefono: '555-000-5006',
      estatus: 'Entrevistado',
      experiencia: '6 años',
      fechaAplicacion: '24/04/2023',
      escolaridad: 'Lic. en Finanzas',
      institucion: 'UNAM',
      anioGraduacion: '2016',
      cvURL: 'https://example.com/cv/daniela-velez.pdf',
      vacanteCodigo: 'PL005',
      vacantePlaza: 'Contador Público',
      vacantePuesto: 'Contador Senior',
      vacanteTipoEmpleado: 'Tiempo Completo',
      vacanteOficio: 'FIN-2023-056',
      vacanteMotivo: 'Reemplazo por jubilación',
      vacanteEstatus: 'Seleccionado(a)',
      vacantePruebas: ['Contabilidad Avanzada'],
      solicitanteFolio: 'SOL-2023-005',
      solicitanteNombre: 'Sofía Ramírez Pérez',
      solicitantePuesto: 'CFO',
      solicitanteAreaCodigo: 'A005',
      solicitanteAreaNombre: 'Finanzas',
      resumenEntrevista: 'Precisa, confiable y con experiencia en auditorías externas.',
      archivoEntrevista: 'https://example.com/entrevistas/daniela-velez.pdf',
    },
    {
      id: 14,
      nombre: 'Gabriel Mendoza',
      email: 'gabriel.mendoza@ejemplo.com',
      telefono: '555-000-5007',
      estatus: 'Entrevistado',
      experiencia: '7 años',
      fechaAplicacion: '25/04/2023',
      escolaridad: 'Lic. en Contaduría',
      institucion: 'UABC',
      anioGraduacion: '2014',
      cvURL: 'https://example.com/cv/gabriel-mendoza.pdf',
      vacanteCodigo: 'PL005',
      vacantePlaza: 'Contador Público',
      vacantePuesto: 'Contador Senior',
      vacanteTipoEmpleado: 'Tiempo Completo',
      vacanteOficio: 'FIN-2023-056',
      vacanteMotivo: 'Reemplazo por jubilación',
      vacanteEstatus: 'Seleccionado(a)',
      vacantePruebas: ['Contabilidad Avanzada'],
      solicitanteFolio: 'SOL-2023-005',
      solicitanteNombre: 'Sofía Ramírez Pérez',
      solicitantePuesto: 'CFO',
      solicitanteAreaCodigo: 'A005',
      solicitanteAreaNombre: 'Finanzas',
      resumenEntrevista: 'Experiencia sólida en fiscal y contabilidad electrónica.',
      archivoEntrevista: 'https://example.com/entrevistas/gabriel-mendoza.pdf',
    },
  ];
  const [modalOpen, setModalOpen] = useState(false);
  const [vacanteSeleccionada, setVacanteSeleccionada] = useState(null);
  const [aptosPorVacante, setAptosPorVacante] = useState({});
  const [contratadosPorVacante, setContratadosPorVacante] = useState({});
  const [tabActiva, setTabActiva] = useState('evaluados');
  const [tempSeleccionados, setTempSeleccionados] = useState([]);
  const [tempContratados, setTempContratados] = useState([]);

  const abrirModal = (vacante) => {
    const codigo = vacante.vacanteCodigo;
    setVacanteSeleccionada(vacante);
    setTempSeleccionados([...aptosPorVacante[codigo] || []]);
    setTempContratados([...contratadosPorVacante[codigo] || []]);
    setTabActiva('evaluados');
    setModalOpen(true);
  };

  const cerrarModal = () => {
    setModalOpen(false);
    setVacanteSeleccionada(null);
    setTempSeleccionados([]);
    setTempContratados([]);
  };

  const candidatosParaVacante = (codigo) => candidatos.filter((c) => c.vacanteCodigo === codigo);

  const toggleApto = (id) => {
    setTempSeleccionados((prev) => (prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]));
  };

  const toggleContratado = (id) => {
    setTempContratados((prev) => (prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]));
  };

  const guardarSeleccionadosComoAptos = () => {
    Modal.confirm({
      title: '¿Confirmar candidatos aptos?',
      content: `Se marcarán ${tempSeleccionados.length} candidato(s) como aptos para esta vacante.`,
      okText: 'Confirmar',
      cancelText: 'Cancelar',
      onOk: () => {
        const codigo = vacanteSeleccionada.vacanteCodigo;
        setAptosPorVacante((prev) => ({ ...prev, [codigo]: tempSeleccionados }));
        notification.success({
          message: 'Guardado exitoso',
          description: `Se guardaron ${tempSeleccionados.length} candidato(s) como apto(s).`,
          placement: 'bottomRight',
        });
        setTabActiva('contratacion');
      },
    });
  };

  const confirmarContratacion = () => {
    Modal.confirm({
      title: '¿Confirmar contratación?',
      content: `Se marcarán ${tempContratados.length} candidato(s) como contratados para esta vacante.`,
      okText: 'Confirmar',
      cancelText: 'Cancelar',
      onOk: () => {
        const codigo = vacanteSeleccionada.vacanteCodigo;
        setContratadosPorVacante((prev) => ({ ...prev, [codigo]: tempContratados }));
        notification.success({
          message: 'Contratación completada',
          description: `Se contrató a ${tempContratados.length} candidato(s).`,
          placement: 'bottomRight',
        });
        cerrarModal();
      },
    });
  };

  return (
    <>
      <Title level={3}>Vacantes Disponibles</Title>
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        {vacantes.map((vacante) => (
          <Card
            key={vacante.id}
            hoverable
            onClick={() => abrirModal(vacante)}
            title={`${vacante.vacantePlaza} - ${vacante.vacanteAreaNombre}`}
          >
            <Text type="secondary">
              Solicitante:
              {vacante.solicitanteNombre}
            </Text>
            <br />
            <Text type="secondary">
              Candidatos evaluados:
              {' '}
              {candidatosParaVacante(vacante.vacanteCodigo).length}
            </Text>
            <br />
            <Tag color="blue">{vacante.vacanteEstatus}</Tag>
          </Card>
        ))}
      </Space>

      <Modal
        open={modalOpen}
        onCancel={cerrarModal}
        width={800}
        footer={
          tabActiva === 'evaluados' ? (
            <Button
              type="primary"
              icon={<CheckCircleOutlined />}
              onClick={guardarSeleccionadosComoAptos}
              disabled={tempSeleccionados.length === 0}
            >
              Guardar Aptos
            </Button>
          ) : (
            <Button
              type="primary"
              icon={<CheckCircleOutlined />}
              onClick={confirmarContratacion}
              disabled={tempContratados.length === 0}
            >
              Confirmar Contratación
            </Button>
          )
        }
        title={`Vacante: ${vacanteSeleccionada?.vacantePlaza}`}
      >
        <Tabs activeKey={tabActiva} onChange={setTabActiva}>
          <TabPane tab="Candidatos Evaluados" key="evaluados">
            <List
              itemLayout="vertical"
              dataSource={candidatosParaVacante(vacanteSeleccionada?.vacanteCodigo || '')}
              renderItem={(candidato) => (
                <List.Item key={candidato.id}>
                  <List.Item.Meta
                    avatar={<UserOutlined />}
                    title={candidato.nombre}
                    description={(
                      <>
                        <Text type="secondary">{candidato.email}</Text>
                        <br />
                        <Tooltip title={candidato.resumenEntrevista}>
                          <Text ellipsis style={{ maxWidth: 600 }}>
                            {candidato.resumenEntrevista}
                          </Text>
                        </Tooltip>
                      </>
                    )}
                  />
                  <Checkbox
                    checked={tempSeleccionados.includes(candidato.id)}
                    onChange={() => toggleApto(candidato.id)}
                  >
                    Marcar como apto
                  </Checkbox>
                </List.Item>
              )}
            />
          </TabPane>

          <TabPane tab="Contratación" key="contratacion">
            <List
              itemLayout="vertical"
              dataSource={
                (vacanteSeleccionada
                  && candidatosParaVacante(vacanteSeleccionada.vacanteCodigo).filter((c) => tempSeleccionados.includes(c.id)))
                || []
              }
              renderItem={(candidato) => (
                <List.Item key={candidato.id}>
                  <List.Item.Meta
                    avatar={<UserOutlined />}
                    title={candidato.nombre}
                    description={(
                      <>
                        <Text type="secondary">{candidato.email}</Text>
                        <br />
                        <Tooltip title={candidato.resumenEntrevista}>
                          <Text ellipsis style={{ maxWidth: 600 }}>
                            {candidato.resumenEntrevista}
                          </Text>
                        </Tooltip>
                      </>
                    )}
                  />
                  <Checkbox
                    checked={tempContratados.includes(candidato.id)}
                    onChange={() => toggleContratado(candidato.id)}
                  >
                    Marcar para contratar
                  </Checkbox>
                </List.Item>
              )}
            />
          </TabPane>
        </Tabs>
      </Modal>
    </>
  );
}
